import {DomainEvent} from './DomainEvent';
import {DeletedEntity} from '../resources/DeletedEntity';

export class DistrictDeleted extends DomainEvent<DeletedEntity> {}
